import React from 'react';
import { useSelector } from 'react-redux';
import { LabelAndValue } from '../../../../../global/components/data-display/label-value';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { TerminationProps } from '../../../models/arc-epi-props';
import { Employee, Employment } from '../../employment/employment-model';
import { EmploymentCombinationTypes } from '../models/termination-form-model';

interface Props {
	employmentTypeCombo: EmploymentCombinationTypes;
	stipEmployment: Employment;
	nonStipEmployment: Employment;
	currentEmployee: Employee;
	isLoa?: boolean;
}
export function EmploymentTerminationSummary(props: Props) {
	const { employmentTypeCombo, stipEmployment, nonStipEmployment, currentEmployee } = props;

	const terminationProps = useSelector<TcsmStates, TerminationProps>(state => state.epiProps?.terminationSettingsState?.epiContent);

	if (!stipEmployment && !nonStipEmployment) return null;

	const employment = employmentTypeCombo === EmploymentCombinationTypes.NonStipendiary
		? nonStipEmployment
		: stipEmployment;

	const EmployerView = () => {
		return (
			<>
				<p>{employment?.employer_name}</p>
				<p>{employment?.employer_location}</p>
				<p>{employment?.employer_country}</p>
			</>
		);
	};

	const getEmploymentTypeLabel = () => {
		switch (employmentTypeCombo) {
			case EmploymentCombinationTypes.Stipendiary:
				return terminationProps?.stipendiaryText;
			case EmploymentCombinationTypes.NonStipendiary:
				return terminationProps?.nonStipendiaryText;
			case EmploymentCombinationTypes.StipAndNonStip:
				return `${terminationProps?.stipendiaryText} and ${terminationProps?.nonStipendiaryText}`;
			default:
				return '';
		}
	};

	return (
		<DividerSection sectionText={props?.isLoa ? terminationProps?.loaTerminateBenefitTitle : terminationProps?.terminationInfoHeader} removeDivider>

			<LabelAndValue label={terminationProps?.employeeLabel} value={currentEmployee?.full_name} />
			<LabelAndValue label={terminationProps?.clientNumberLabel} value={currentEmployee?.masked_client_number} />
			<LabelAndValue label={terminationProps?.employerLabel} value={<EmployerView />} />
			<LabelAndValue label={terminationProps?.employmentTypeLabel} value={getEmploymentTypeLabel()} />
			<LabelAndValue label={terminationProps?.hireDateLabel} value={getFormattedDate(employment?.hire_date)} />
		</DividerSection>

	);
}


EmploymentTerminationSummary.defaultProps = {
	isLoa: false,
};